import { forwardRef } from "react";
import { useAppSelector } from "toolkit/hooks";

import { UsersListItem } from "../UsersListItem/UsersListItem";
import styles from "./UsersList.module.sass";

interface UsersListProps {
	archive: boolean;
	select: boolean;
	searchValue: string | number;
	outline: (id: number) => string;
	read: boolean;
}

export const UsersList = forwardRef<HTMLDivElement | null, UsersListProps>(
	({ archive, read, select, searchValue, outline }, ref) => {
		const usersList = useAppSelector((state) => state.users.usersList);
		return (
			<div data-comment-false={true} ref={ref} className={styles.body}>
				{usersList.map((user: any) => (
					<UsersListItem
						read={read}
						outline={outline}
						key={user.id}
						user={user}
						archive={archive}
						select={select}
						searchValue={searchValue}
					/>
				))}
			</div>
		);
	},
);
